module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.step === 1) ? _c('section', {
    staticClass: "content cleafix"
  }, [_c('form', [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("\n        用户初始化\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-body"
  }, [_c('div', {
    staticClass: "input-item show-info"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("姓名:")]), _vm._v(" "), _c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.realname))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item show-info"
  }, [_vm._m(0), _vm._v(" "), _c('select', {
    staticClass: "input col-xs-9",
    attrs: {
      "name": "username",
      "id": ""
    }
  }, _vm._l((_vm.usernames), function(un) {
    return _c('option', {
      key: un,
      domProps: {
        "value": un
      }
    }, [_vm._v(_vm._s(un))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "input-item clearfix"
  }, [_c('div', {
    staticClass: "col-xs-12 clearfix"
  }, [_c('div', {
    staticClass: "row clearfix"
  }, [_c('div', {
    staticClass: "col-sm-7 n-p-l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.verifyCode),
      expression: "verifyCode",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "blur": [function($event) {
        _vm.validateCode()
      }, function($event) {
        _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value.trim()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 n-p-r n-p-l"
  }, [_c('button', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "disabled": _vm.reset.disabled
    },
    on: {
      "click": function($event) {
        _vm.sendVerifyCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.reset.text))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.code))])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.nickname),
      expression: "nickname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "nickname",
      "placeholder": "昵称:风清扬",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.nickname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nickname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "密码：6-16位字符、数字、特殊字符",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.rpassword),
      expression: "rpassword",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "rpassword",
      "placeholder": "再次输入：6-16位字符、数字、特殊字符",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.rpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rpassword = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-tips"
  }, [_vm._v(_vm._s(_vm.error.password))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    staticClass: "btn btn-primary btn-md col-xs-12",
    attrs: {
      "type": "button",
      "value": "初始化用户"
    },
    on: {
      "click": function($event) {
        _vm.registerFunc()
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "init-content"
  }, [_c('div', {
    staticClass: "step-content"
  }, [(_vm.category === 1) ? _c('form', {
    staticClass: "company-info"
  }, [_c('h1', {
    staticClass: "form-head"
  }, [_vm._v("完善个人信息")]), _vm._v(" "), _c('div', {
    staticClass: "input-item n-m-b"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "alt": _vm.user.nickname,
      "src": _vm.user.avatar
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hidden-file",
    attrs: {
      "type": "file",
      "name": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.uploadAvatar($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "input-item show-info text-center"
  }, [_c('span', {
    staticClass: "email"
  }, [_vm._v(_vm._s(_vm.user.nickname))])]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.realname),
      expression: "user.realname",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "真实姓名：华宇互联",
      "required": "required",
      "autocomplete": "off",
      "readonly": "readonly",
      "disabled": "disabled"
    },
    domProps: {
      "value": (_vm.user.realname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.realname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.qq),
      expression: "user.qq",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "QQ：10000",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.qq)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.qq = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.user.signature),
      expression: "user.signature",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input textarea",
    attrs: {
      "resize": "none",
      "placeholder": "个性签名：人在江湖飘，就是要挨刀！",
      "required": "required",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.user.signature)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.signature = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-item"
  }, [_c('input', {
    staticClass: "btn btn-md btn-primary col-xs-12",
    attrs: {
      "type": "button",
      "value": "完善信息，开始测评"
    },
    on: {
      "click": function($event) {
        _vm.completeInfo()
      }
    }
  })])]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v("用户名:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-259ccda5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/initialize.vue
// module id = 468
// module chunks = 1